import { makeStyles, Theme } from '@material-ui/core';
import { SuggestionCardIcon } from '@assets';
import { CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { ServiceSurveyCardProps } from './ServiceSurveyCard';
import { useContext } from 'react';
import { ServiceSurveyContext } from '../ServiceSurvey';

const ServiceSurveyMobileCard = ({
  bgcolor = colorSet.gray100
}: ServiceSurveyCardProps) => {
  const { suggestionCard } = useSuggestionCardElementMobileStyles({
    bgcolor
  });
  const { setSurveyOpen } = useContext(ServiceSurveyContext);

  return (
    <button
      className={suggestionCard}
      onClick={() =>
        setSurveyOpen && setSurveyOpen({ progress: true, complete: false })
      }
    >
      <CustomizedTypography
        variant="body1"
        fontWeight="500"
        color="textPrimary"
      >
        원하는 제조서비스가 없나요?
      </CustomizedTypography>
      <div className="image-box">
        <img
          src={SuggestionCardIcon}
          width={48}
          height={48}
          alt="suggestionCard"
        />
      </div>
    </button>
  );
};

const useSuggestionCardElementMobileStyles = makeStyles<
  Theme,
  ServiceSurveyCardProps
>({
  suggestionCard: {
    width: '100%',
    height: 80,
    borderRadius: '16px',
    backgroundColor: ({ bgcolor }) => bgcolor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 20px',
    border: 'none',
    '& .image-box': {
      width: '64px',
      height: '64px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    '&:hover': {
      cursor: 'pointer'
    }
  }
});

export default ServiceSurveyMobileCard;
